"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const __1 = require("../..");
const marker_drawable_1 = require("./marker.drawable");
const marker_offset_drawable_1 = require("./marker.offset.drawable");
class CollectionModelDrawableState {
    constructor(collection, captureId) {
        this.drawables = mobx_1.observable.map();
        this.collection = collection;
        this.captureId = captureId;
    }
    clone() {
        const copy = new CollectionModelDrawableState(this.collection, this.captureId);
        for (const drawable of Array.from(this.drawables.values())) {
            drawable.clone(copy); // Cloning a drawable automatically inserts the new drawable into the new drawableState.
        }
        return copy;
    }
    get empty() {
        return this.drawables.size === 0;
    }
    /**
     * Returns the base drawable
     */
    get base() {
        for (const drawable of this.getAllDrawables()) {
            if (marker_drawable_1.CollectionModelDrawableMarker.isBase(drawable)) {
                return drawable;
            }
        }
        return null;
    }
    get baseOffset() {
        for (const drawable of this.getAllDrawables()) {
            if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawable)) {
                return drawable;
            }
        }
        return null;
    }
    get insightMask() {
        var _a;
        return (_a = this.getAllDrawables().find((d) => d instanceof __1.CollectionModelDrawableMask)) !== null && _a !== void 0 ? _a : null;
    }
    hasVisibleInsightMasks(enabledDetectionGroups, log) {
        for (const drawable of this.drawables.values()) {
            if (!(drawable instanceof __1.CollectionModelDrawableMask)) {
                continue;
            }
            if (drawable.getVisibleSvgDetectionGroups(enabledDetectionGroups, log)) {
                return true;
            }
        }
        return false;
    }
    clear() {
        for (const drawable of this.getAllDrawables()) {
            drawable.remove();
        }
    }
    hasDrawable(drawableId) {
        return this.drawables.has(drawableId);
    }
    getDrawable(drawableId) {
        if (!this.drawables.has(drawableId)) {
            throw new Error(`Cannot find drawable (id=${drawableId}) for capture ${this.captureId}`);
        }
        const drawable = this.drawables.get(drawableId);
        if (!drawable) {
            throw new Error(`Cannot find drawable (id=${drawableId}) for capture ${this.captureId} -- after "has" check succeeded!`);
        }
        return drawable;
    }
    getAllDrawables() {
        return Array.from(this.drawables.values());
    }
    values() {
        return this.getAllDrawables();
    }
    hasMeasurements() {
        return !this.empty;
    }
    hasUserMeasurements() {
        return this.getAllDrawables().some((drawable) => drawable.isUserMeasurement);
    }
    hasOnlyInsightDetections() {
        const drawables = this.getAllDrawables();
        return drawables.length > 0 && drawables.every((drawable) => drawable.isInsightMeasurement);
    }
    hasInsightDetections() {
        return this.getAllDrawables().some((drawable) => drawable.isInsightMeasurement);
    }
    hasAppliedInsightDetections() {
        return this.getAllDrawables().some((drawable) => { var _a; return drawable instanceof marker_drawable_1.CollectionModelDrawableMarker && ((_a = drawable.insight) === null || _a === void 0 ? void 0 : _a.applied); });
    }
    clearInsightDetections() {
        for (const drawable of this.getAllDrawables()) {
            if (drawable.isInsightMeasurement) {
                drawable.remove();
            }
        }
    }
    /**
     * @deprecated Use {@link getCaptureAsync()} instead.
     */
    get capture() {
        return this.collection.state.getCapture(this.captureId);
    }
    getCaptureAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.collection.state.loader.Capture.getById(this.captureId).fetch();
        });
    }
    equals(other) {
        // This function is written to perform every comparison every time so that
        // mobx can track the dependencies of the equality process.
        let equal = true;
        if (this.captureId !== other.captureId) {
            equal = false;
        }
        const keys = Array.from(this.drawables.keys());
        const otherKeys = Array.from(other.drawables.keys());
        if (keys.length !== otherKeys.length) {
            equal = false;
        }
        if (keys.some((key) => !otherKeys.includes(key))) {
            equal = false;
        }
        if (otherKeys.some((key) => !keys.includes(key))) {
            equal = false;
        }
        for (const [drawableId, drawable] of Array.from(this.drawables.entries())) {
            const otherDrawable = other.drawables.get(drawableId);
            if (!otherDrawable) {
                equal = false;
            }
            else if (!drawable.equals(otherDrawable)) {
                equal = false;
            }
        }
        return equal;
    }
}
exports.CollectionModelDrawableState = CollectionModelDrawableState;
tslib_1.__decorate([
    mobx_1.observable
], CollectionModelDrawableState.prototype, "drawables", void 0);
//# sourceMappingURL=drawable.state.js.map